import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 4v16l-6 -5.5","key":"svg-0"}],["path",{"d":"M14 20v-16l6 5.5","key":"svg-1"}]]

/**
 * IconTransferVertical
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJhbnNmZXItdmVydGljYWwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEwIDR2MTZsLTYgLTUuNSIgLz4KICA8cGF0aCBkPSJNMTQgMjB2LTE2bDYgNS41IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/transfer-vertical
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTransferVertical = createReactComponent('outline', 'transfer-vertical', 'TransferVertical', __iconNode);

export default IconTransferVertical;